import React from 'react'
import {Container, Row, Col} from 'reactstrap'
import choose from '../../media/choose.jpg'
import Saperator from '../Saperator'

const WhyUs = () => {
  return (
    <Container>
        <div id='whyUs-section' className='whyUs-section'> 
          <div className="cc-heading-a text-center"> Why Choose Us </div>

          <Row className=''>
            <Col lg={8}>
              <div className='section-content mx-2'>
                <div className='secondary-heading'>Experience the Best Export Services with AMT</div>
                <div className='cc-small-text'>
                    AMT is a leading exporter committed to providing exceptional services to businesses across all industries. Our team of experts has extensive experience in international trade, and we are dedicated to ensuring that your shipment is delivered on time and in perfect condition. We pride ourselves on our attention to detail and our commitment to customer satisfaction. Whether you need to export electronics, textiles, or food products, we can help.
                </div>
              </div>
            </Col>
            <Col lg={4}>
              <div className='mx-2'>
                <img src={choose} alt="Why Choose Us" width={'100%'}/>
              </div>
            </Col>
          </Row>

        </div>
        <Saperator/>
    </Container>
  )
}

export default WhyUs